import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { MyProfileForm } from '@components/molecules/MyProfileForm';
import { UserAccountContainer } from '@components/organisms/UserAccountContainer';

export const MyProfilePage = () => {
    const { t } = useTranslation();

    const translations = {
        title: t('my-profile.metatags.title'),
        description: t('my-profile.metatags.description'),
        pageTitle: t('my-profile.page.title'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProfile,
        index: false,
    });

    return (
        <UserAccountContainer title={translations.pageTitle}>
            <div className="mt-3">
                <MyProfileForm />
            </div>
        </UserAccountContainer>
    );
};
